import React from 'react';
import { Helmet } from 'react-helmet-async';
import About from '../components/About';

const AboutPage = () => {
  return (
    <div className="pt-[72px]">
      <Helmet>
        <title>Massageterapeut Trine Agerbo | MassageterapiCPH — massageterapicph.dk</title>
        <meta name="description" content="Velkommen til MassageterapiCPH. Jeg hedder Trine, er Integrativ Massageterapeut (RAB), og den 1. januar 2026 åbnede jeg klinik i det gode hus IFIB på Nørrebro." />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Massageterapeut Trine Agerbo | MassageterapiCPH — massageterapicph.dk" />
        <meta property="og:description" content="Velkommen til MassageterapiCPH. Jeg hedder Trine, er Integrativ Massageterapeut (RAB), og den 1. januar 2026 åbnede jeg klinik i det gode hus IFIB på Nørrebro." />
        <meta property="og:image" content="" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Massageterapeut Trine Agerbo | MassageterapiCPH — massageterapicph.dk" />
        <meta property="twitter:description" content="Velkommen til MassageterapiCPH. Jeg hedder Trine, er Integrativ Massageterapeut (RAB), og den 1. januar 2026 åbnede jeg klinik i det gode hus IFIB på Nørrebro." />
        <meta property="twitter:image" content="" />
      </Helmet>
      <About />
    </div>
  );
};

export default AboutPage;
